<template>
  <div class="dropdown-container" ref="container">
    <button @click="toggleDropdown" class="dots-button">
      ⋮
    </button>

    <div
      ref="popover"
      v-show="isOpen"
      class="dropdown-menu"
      :style="dropdownPosition"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "DotsDropdown",
  data() {
    return {
      isOpen: false,
      dropdownPosition: {
        position: "fixed",
        top: 0,
        right: 0,
        zIndex: 9999,
        // visibility: "hidden"
        display: "none"
      }
    };
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
      if (this.isOpen === true) {
        this.$nextTick(() => {
          this.calculatePosition();
        });
      }
    },
    calculatePosition() {
      if (!this.isOpen) return;

      const parentEmt = this.$el.closest(".table-parent");

      const rect = this.$refs.container.getBoundingClientRect();
      const parentRect = parentEmt.getBoundingClientRect();

      const isOverflowingTop = rect.bottom < parentRect.top;
      const isOverflowingBottom = rect.bottom > parentRect.bottom;

      const isVisible =
        isOverflowingTop || isOverflowingBottom ? "none" : "block";

      this.dropdownPosition = {
        position: "fixed",
        top: `${rect.bottom + 4}px`,
        right: `${window.innerWidth - rect.right}px`,
        zIndex: 9999,
        display: isVisible
        // visibility: isVisible
      };
    },
    handleClickOutside(event) {
      if (
        !this.$el.contains(event.target) &&
        !event.target.closest(".dropdown-menu")
      ) {
        this.isOpen = false;
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    window.addEventListener("scroll", this.calculatePosition, true);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
    window.removeEventListener("scroll", this.calculatePosition, true);
  }
};
</script>

<style scoped>
.dropdown-container {
  display: inline-block;
}

.dots-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  font-size: 20px;
  line-height: 1;
}

.dropdown-menu {
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 150px;
}

.dropdown-item {
  padding: 8px;
  cursor: pointer;
}
</style>
